$(document).ready(function () {
    var winWidth = $(window).width();

    const isDesktop = winWidth >= 1200;

    $('#main-gallery').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        asNavFor: isDesktop ? '.thumb-gallery' : null,
        rows: 0,
        swipe: false,
        touchMove: false,
        draggable: false
    });

    if (winWidth > 1200) {
        $('.thumb-gallery').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '#main-gallery',
            dots: false,
            centerMode: false,
            focusOnSelect: true,
            vertical: true,
            arrows: true,
            rows: 0
        });
    }

    $(document).on('click', '.quantity__button', function () {
        const $input = $(this).closest('.product-quantity').find('input');
        let current_qtty = parseInt($input.val(), 10);

        if ($(this).attr('name') === 'plus') {
            current_qtty += 1;
        } else {
            if (current_qtty > 1) {
                current_qtty -= 1;
            }
        }

        $input.val(current_qtty).trigger('change');
    });

    function formatMoney(value) {
        if (isNaN(value)) return '';
        return '£' + value.toLocaleString('en-GB', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    function hasQuantityBreaks() {
        return $('.qtty-break-card').length > 0;
    }

    function updateQttyBreaksTable(basePrice) {
        if (!hasQuantityBreaks() || isNaN(basePrice)) return;

        $('.qtty-break-card').each(function () {
            const discount = parseFloat(this.dataset.discount);
            if (isNaN(discount)) return;

            const discountedPrice = basePrice * (1 - discount / 100);

            this.dataset.price = discountedPrice.toFixed(2);

            if (isVatIncluded()) {
                const vatDiscountedPrice = addVat(discountedPrice);
                $(this).find('span').text('£' + vatDiscountedPrice.toFixed(2));
            } else {
                $(this).find('span').text(formatMoney(discountedPrice));
            }
        });
    }

    function getVariantQttyBreaks(qtty, basePrice) {
        if (!hasQuantityBreaks() || isNaN(basePrice)) {
            return basePrice;
        }

        let resolvedPrice = basePrice;

        $('.qtty-break-card').each(function () {
            const min = parseInt(this.dataset.min, 10);
            const price = parseFloat(this.dataset.price);

            if (!isNaN(min) && !isNaN(price) && qtty >= min) {
                resolvedPrice = price;
            }
        });

        return resolvedPrice;
    }

    function updateVariant() {
        const $wrapper = $('.product-variants');
        
        if ($wrapper.length) {
            const sectionId = $wrapper.data('section-id');
            if (!sectionId) return;

            const optionValueIds = $wrapper.find('select')
                .map(function () {
                    return $(this).val();
                })
                .get()
                .filter(Boolean);

            const params = optionValueIds.length
                ? `&option_values=${optionValueIds.join(',')}`
                : '';

            fetch(`${window.location.pathname}?section_id=${sectionId}${params}`)
                .then(res => res.text())
                .then(html => {
                    const doc = new DOMParser().parseFromString(html, 'text/html');

                    const newVariants = doc.querySelector('.product-variants');
                    if (newVariants) {
                        $wrapper.html(newVariants.innerHTML);
                    }

                    const variantData = doc.querySelector('#variant-data');
                    if (!variantData) return;

                    const variantId = variantData.dataset.variantId;
                    const available = variantData.dataset.available === 'true';
                    const basePrice = parseFloat(variantData.dataset.price);

                    if (!variantId || isNaN(basePrice)) return;

                    const qttyInput = $('.variant-product-form input[name="quantity"]');
                    const qtty = parseInt(qttyInput.val(), 10) || 1;

                    updateQttyBreaksTable(basePrice);

                    const finalPrice = getVariantQttyBreaks(qtty, basePrice);

                    $('.product-form input[name="id"]').val(variantId);
                    $('.product-form button[type="submit"]').prop('disabled', !available);

                    if (isVatIncluded()) {
                        const vatPrice = addVat(finalPrice);
                        $('.product-right .price').html(formatMoney(vatPrice));
                    } else {
                        $('.product-right .price').html(formatMoney(finalPrice));
                    }
                })
                .catch(err => {
                    console.error('Variant update failed', err);
                });
        } else {
            const basePrice = parseFloat($('.price').attr('data-base-price'));

            const qttyInput = $('.variant-product-form input[name="quantity"]');
            const qtty = parseInt(qttyInput.val(), 10) || 1;

            updateQttyBreaksTable(basePrice);

            const finalPrice = getVariantQttyBreaks(qtty, basePrice);

            if (isVatIncluded()) {
                const vatPrice = addVat(finalPrice);
                $('.product-right .price').html(formatMoney(vatPrice));
            } else {
                $('.product-right .price').html(formatMoney(finalPrice));
            }
        }
    }

    function collectVariantProperties() {
        const properties = {};

        const $options = $('.product-variant');
        if (!$options.length) return null;

        $options.each(function () {
            const label = $(this).find('label').first().text().trim();
            const $select = $(this).find('select');

            if (!$select.length) return;

            const value = $select.find('option:selected').text().trim();

            if (label && value) {
                properties[label] = value;
            }
        });

        return Object.keys(properties).length ? properties : null;
    }

    $(document).on(
        'change',
        '.product-variants select, .variant-product-form input[name="quantity"]',
        updateVariant
    );

    $(document).on('submit', '.variant-product-form', function (e) {
        e.preventDefault();

        const $form = $(this);
        const variantId = $form.find('input[name="id"]').val();

        if (!variantId) {
            alert('Please select a product option.');
            return;
        }

        const quantity = parseInt(
            $form.find('input[name="quantity"]').val(),
            10
        ) || 1;

        const properties = collectVariantProperties();

        const payload = {
            id: variantId,
            quantity: quantity
        };

        if (properties) {
            payload.properties = properties;
        }

        const $button = $form.find('button[type="submit"]');
        $button.prop('disabled', true).addClass('loading');

        showLoader?.();
        openCart?.();

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(payload)
        })
            .then(res => {
                if (!res.ok) throw res;
                return res.json();
            })
            .then(data => {
                renderCartDrawer?.();
            })
            .catch(async err => {
                let errorMsg = 'Unable to add item to cart';

                try {
                    const errorData = await err.json();
                    errorMsg = errorData.description || errorMsg;
                } catch (e) {}

                alert(errorMsg);
            })
            .finally(() => {
                $button.prop('disabled', false).removeClass('loading');
            });
    });

    function updateAddons() {
        const $price = $('.price');

        if (!$price.length) return;

        const originalBasePrice = parseFloat($price.data('base-price'));
        const baseSku = $price.data('base-sku');

        const qttyInput = $('.custom-product-form input[name="quantity"]');
        const qtty = parseInt(qttyInput.val(), 10) || 1;

        let addonsTotal = 0;
        let skuParts = [baseSku];

        $('.product-addon-select').each(function () {
            const $option = $(this).find('option:selected');
            const price = parseFloat($option.data('price')) || 0;
            const sku = $option.data('sku');

            addonsTotal += price;

            if (sku) {
                skuParts.push(sku);
            }
        });

        $('.product-addon input[type="radio"]:checked').each(function () {
            const price = parseFloat($(this).data('price')) || 0;
            const sku = ($(this).data('sku') || '').trim();

            addonsTotal += price;

            if (sku) {
                skuParts.push(sku);
            }
        });

        $('.product-addon input[type="checkbox"]:checked').each(function () {
            const price = parseFloat($(this).data('price')) || 0;
            const sku = ($(this).data('sku') || '').trim();

            addonsTotal += price;

            if (sku) {
                skuParts.push(sku);
            }
        });

        $('.product-addon-button.is-active').each(function () {
            const price = parseFloat($(this).data('price')) || 0;
            const sku = $(this).data('sku');

            addonsTotal += price;

            if (sku) {
                skuParts.push(sku);
            }
        });

        const totalWithoutQuantityDiscount = originalBasePrice + addonsTotal;
        
        updateQttyBreaksTable(totalWithoutQuantityDiscount);
        
        let finalPrice = totalWithoutQuantityDiscount;
        
        if ($('.qtty-break-data').length) {
            $('.qtty-break-card').each(function () {
                const min = parseInt(this.dataset.min, 10);
                const price = parseFloat(this.dataset.price);

                if (!isNaN(min) && !isNaN(price) && qtty >= min) {
                    finalPrice = price;
                }
            });
        }

        const finalSku = skuParts.join('-');
        const formattedPrice = finalPrice;

        if (isVatIncluded()) {
            const vatPrice = addVat(formattedPrice).toFixed(2);
            $price.attr('data-current-price', formattedPrice).attr('data-current-sku', finalSku).html(formatMoney(vatPrice));
        } else {
            $price.attr('data-current-price', formattedPrice).attr('data-current-sku', finalSku).html(formatMoney(formattedPrice));
        }
    }

    $(document).on(
        'change',
        '.product-addon-select, .product-addon input[type="radio"], .product-addon input[type="checkbox"], .custom-product-form input[name="quantity"]',
        updateAddons
    );

    $(document).on('click', '.product-addon-button', function () {
        const group = $(this).data('group');

        if (group) {
            $('.product-addon-button[data-group="' + group + '"]').removeClass('active-option');
        }

        $(this).addClass('active-option');
        updateAddons();
    });

    async function addVariant(pid, title, handle, image, price, sku, weight, qtty, properties) {
        if (!isNaN(pid) && !isNaN(price) && sku && !isNaN(weight)) {
            const variant_data = {
	            pid,
                title,
                handle,
                image,
	            price,
	            sku,
	            weight,
                qtty,
                properties
	        };

            try {
                const response = await fetch(
                    "https://app.wheeliebins.co.uk/api/create-variant", {
                        method: "POST",
                        headers: {
                        "Content-Type": "application/json",
                        },
                        body: JSON.stringify(variant_data),
                    }
                );

                if (!response.ok) {
                    const error = await response.text();
                    console.error("Create variant failed:", error);
                    alert("Something went wrong with this product. Please chat with us or give us a call, and we’ll help you out.");
                    return null;
                }

                const data = await response.json();
                return data;
            } catch (err) {
                console.error('Request failed:', err);
                return null;
            }
        } else {
            alert('Something seems wrong with this product, please contact support.');
            return null;
        }
    }

    async function collectAddonProperties() {
    	let properties = {};

        $('.product-addon').each(function(index, el) {
            var name = $(this).attr('data-addon-name');

    		if ($(this).attr('data-type') == 'type-drop_down') {
                var value = $(this).find('select').val();

				if (name && value) {
	            	properties[name] = value;
	        	}
			} else if ($(this).attr('data-type') == 'type-radio') {
				var value = $(this).find('input[type="radio"]:checked').val();

				if (name && value) {
	            	properties[name] = value;
	        	}
			} else if ($(this).attr('data-type') == 'type-checkbox') {
				let checkboxCount = $(this).find('input[type="checkbox"]:checked').length;
			    if (checkboxCount > 1) {
			    	let counter = 1;
			    	$(this).find('input[type="checkbox"]:checked').each(function(index, el) {
			    		var value = $(this).val();

				    	if (name && value) {
		            		properties[name + ' ' + counter] = value;
		            		counter++;
		        		}	
			    	});
			    } else {
			    	var value = $(this).find('input[type="checkbox"]:checked').val();

			    	if (name && value) {
	            		properties[name] = value;
	        		}
			    }
			}
    	});

    	return properties;
    }
    
    $(document).on('submit', '.custom-product-form', async function (e) {
        e.preventDefault();

        var formValid = true;

        $('.product-addon').each(function() {
            const req = $(this).attr('data-required');
            if (req == 'required') {
                const option_type = $(this).attr('data-type');
                if (option_type == 'type-button') {
                    if (!$(this).find('.button-options button.active-option').length) {
                        formValid = false;
                    }
                } else if (option_type == 'type-drop_down') {
                    var hasValue = $(this).find('select').find(':selected').val();
                    if (!hasValue || hasValue == 'Select') {
                        formValid = false;
                    }
                } else if (option_type == 'type-radio') {
                    if (!$(this).find('input[type="radio"]:checked').val()) {
                        formValid = false;
                    }
                }
            }
        });

        if (!formValid) {
            alert("Please select all the required fields to proceed.");
        } else {
            showLoader?.();
            openCart?.();

            const $form = $(this);
            const $button = $form.find('button[type="submit"]');
            $button.prop('disabled', true).addClass('loading');

            const pid = $('.product-addons').attr('data-pid');
            const title = $('input[name=p_title]').val();
            const handle = $('input[name=p_handle]').val();
            const image = $('input[name=p_image]').val();
            const price = $('.price').attr('data-current-price');
            const sku = $('.price').attr('data-current-sku');
            const weight = $('.product-addons').attr('data-weight');
            const properties = await collectAddonProperties();
            const qtty = $('.product-right input[name="quantity"]').val();

            const variant_id = await addVariant(pid, title, handle, image, price, sku, weight, qtty, properties);

            if (variant_id) {
			    const product_data = {
					id: variant_id,
					quantity: qtty,
					properties: properties
				};

				fetch('/cart/add.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(product_data),
				}).then(response => {
					if (!response.ok) {
						throw new Error('Failed to add to cart.');
					}
					return response.json();
				}).then(cartItem => {
					renderCartDrawer();
				}).catch(error => {
					console.error('Error adding to cart:', error);
				});
			}
        }
    });

    $('#vat-switch').on('change', function() {
        if ($(this).is(':checked')) {
            $('.product-right .vat-switch').addClass('vat-active');

            if (!$('.header-icons .switch-wrapper').hasClass('header-vat-active')) {
                $('.header-icons .switch-wrapper').addClass('header-vat-active');
                $('.header .vat-text').text('Inc Vat.');
            }
        } else {
            $('.product-right .vat-switch').removeClass('vat-active');

            if ($('.header-icons .switch-wrapper').hasClass('header-vat-active')) {
                $('.header-icons .switch-wrapper').removeClass('header-vat-active');
                $('.header .vat-text').text('Ex Vat.');
            }
        }

        if ($('.variant-product-form').length) {
            updateVariant();
        } else {
            updateAddons();
        }
    });

    $('.product-accordion h2').on('click', function () {
        if ($(this).parent().hasClass('accordion-opened')) {
            $(this).parent().removeClass('accordion-opened');
            $(this).parent().find('.product-accordion-content').slideUp();
        } else {
            $(this).parent().addClass('accordion-opened');
            $(this).parent().find('.product-accordion-content').slideDown();
        }
    });

    $('.product-trustpilot a').on('click', function (e) {
        e.preventDefault();

        $('html, body').animate({
            scrollTop: $('.product-reviews').offset().top-160
        }, 600);

        $('.product-reviews h2').trigger('click');
    });

    const triggerPoint = $('form[action="/cart/add"]').offset().top;

    $(window).on('scroll', function () {
        $(this).scrollTop() > triggerPoint
            ? $('.product-bar').addClass('is-visible')
            : $('.product-bar').removeClass('is-visible');
    });

    $(window).on('pageshow', function(event) {
		$('.product-options select').trigger('change');
	});

    $('.chat-now').on('click', function(e) {
    	e.preventDefault();

        window.tidioChatApi.show();
        window.tidioChatApi.open();
    });
});

lightGallery(document.getElementById('main-gallery'), {
    selector: '.main-slide-item',
    download: false
});